module.exports = __webpack_public_path__ + "static/media/check-valid.8715bfbb.svg";